export default "__VITE_ASSET__BxJkbX1z__"